module.exports = __webpack_public_path__ + "static/media/5051.c09c60ef.jpg";